// extracted by mini-css-extract-plugin
module.exports = {"player":"index_player_2mT6B"};